import { useState, useEffect } from 'react';
import nav from '../nav';
import { routes } from '../../../routes';

/* Filter nav items based on the roles defined in the route and the current user's permissions. */
function filterNavItemsByRoutePermissions(navArg, currentUserRole) {
  const findRouteRoles = (path) => routes.find((x) => x.path?.toLowerCase() === path?.toLowerCase())?.role;
  const checkRouteRoles = (routeRoles) => routeRoles.some((x) => x === currentUserRole);

  // Determine which child routes should be shown
  const filterChildRoutes = (rootItem) => rootItem.children?.filter((childItem) => {
    const rootItemChildRouteRules = findRouteRoles(rootItem?.url + childItem?.url);

    // If we don't find any routes allow it to be shown
    if (!rootItemChildRouteRules?.length) return true;

    // If we find a routes but they don't have the correct role, remove them
    return rootItemChildRouteRules.some((x) => x === currentUserRole);
  });

  // Filter out any root levels that we don't need
  let rootItems = [];
  for (let i = 0; i < navArg.length; i += 1) {
    const rootItem = navArg[i];

    // Retrieve route permissions. If we don't find any matches we don't remove the item.
    const routeRoles = findRouteRoles(rootItem.url);

    // If we find a matching route but this user doesn't have the role remove the item
    if (!routeRoles?.length || checkRouteRoles(routeRoles)) {
      rootItems.push({ ...rootItem, children: filterChildRoutes(rootItem) });
    }
  }

  // Remove any
  rootItems = rootItems.filter((x) => !x.onlyShowIfHasChildren || x.children?.length > 0);

  return rootItems;
}

function useFilterNavByRoutePermissionsHook(currentUserRole) {
  const [ filteredNavItems, setFilteredNavItems ] = useState(nav);

  useEffect(() => {
    setFilteredNavItems(filterNavItemsByRoutePermissions(nav, currentUserRole));
  }, [ setFilteredNavItems, currentUserRole ]);

  return filteredNavItems;
}

export {
  useFilterNavByRoutePermissionsHook,
  filterNavItemsByRoutePermissions,
};
